import logoUrl from './arrow-master-logo.webp';

/** DOM loading screen shown while the game logs in and downloads its levels. */
export class LoadingView {
  private readonly root = document.createElement('div');
  private readonly bar: HTMLElement;
  private readonly status: HTMLElement;

  constructor(host: HTMLElement) {
    this.root.className = 'loading';
    this.root.innerHTML = `<img class="loading-logo" src="${logoUrl}" alt="Arrow Master" draggable="false"><div class="loading-track"><div class="loading-fill"></div></div><p class="loading-status" role="status" aria-live="polite"></p>`;
    this.bar = this.root.querySelector<HTMLElement>('.loading-fill')!;
    this.status = this.root.querySelector<HTMLElement>('.loading-status')!;
    host.appendChild(this.root);
  }

  /** 0 to 1. */
  setProgress(progress: number): void {
    this.bar.style.width = `${Math.round(Math.max(0, Math.min(1, progress)) * 100)}%`;
  }

  setStatus(text: string): void {
    this.status.textContent = text;
  }

  destroy(): void {
    this.root.remove();
  }
}
